/* ==========================================================================
   Two-image product feature
   - Entrance animation (fade-up), gated on data-tipf-ready so content is
     visible without JS. Honors prefers-reduced-motion + the theme editor.
   - AJAX quick-add: adds the selected product's first available variant to
     the cart, then notifies any cart drawer via custom events.
   Loaded once even across multiple section instances.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__twoImageProductFeatureInit) return;
  window.__twoImageProductFeatureInit = true;

  var forEach = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CART_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ----------------------------------------------------- entrance animation */
  function initAnim(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll('.two-image-product-feature--animate:not([data-tipf-ready])');
    if (!els.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      forEach(els, function (el) { el.setAttribute('data-tipf-ready', ''); el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      forEach(entries, function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    forEach(els, function (el) { el.setAttribute('data-tipf-ready', ''); io.observe(el); });
  }

  /* -------------------------------------------------------------- quick add */
  function setState(btn, state) {
    btn.classList.remove('is-loading', 'is-success', 'is-error');
    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('aria-busy');
      if (state === 'success' || state === 'error') btn.classList.add('is-' + state);
    }
  }

  // Announce the outcome to screen readers via a visually-hidden live region
  // that lives OUTSIDE the button (a button's aria-label hides its descendants).
  function announce(btn, kind) {
    var panel = btn.closest && btn.closest('.two-image-product-feature__panel');
    var status = panel && panel.querySelector('.two-image-product-feature__qa-status');
    if (!status) return;
    if (kind === 'success') {
      status.setAttribute('role', 'status');
      status.textContent = status.getAttribute('data-added') || 'Added to cart';
    } else if (kind === 'error') {
      status.setAttribute('role', 'alert');
      status.textContent = status.getAttribute('data-error') || 'Could not add to cart';
    } else {
      status.textContent = '';
    }
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    setState(btn, 'loading');

    fetch(CART_ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) { return res.json().then(function (data) { throw data; }); }
        return res.json();
      })
      .then(function () {
        setState(btn, 'success');
        announce(btn, 'success');
        // This theme's cart drawer re-renders/opens on a bubbling "cart:update".
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        // Generic events for other drawers / forward-compat (harmless if unused).
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        window.setTimeout(function () { setState(btn, 'idle'); announce(btn, 'idle'); }, 2000);
      })
      .catch(function (err) {
        setState(btn, 'error');
        announce(btn, 'error');
        if (window.console) console.warn('[two-image-product-feature] quick add failed', err);
        window.setTimeout(function () { setState(btn, 'idle'); announce(btn, 'idle'); }, 2500);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.two-image-product-feature__quick-add');
    if (!btn) return;
    e.preventDefault();
    // Block during the in-flight request AND the brief success-revert window,
    // but still allow retry after an error.
    if (btn.getAttribute('aria-busy') === 'true' || btn.classList.contains('is-success')) return;
    quickAdd(btn);
  });

  /* -------------------------------------------------------------- bootstrap */
  function boot() { initAnim(document); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) { initAnim(e.target || document); });
})();
